export const leave: Record<string, string> = {
  // Leave balance + history
  'leave.myBalance': 'Số ngày phép của tôi',
  'leave.earned': 'Ngày phép được cấp',
  'leave.used': 'Đã sử dụng',
  'leave.remaining': 'Còn lại',
  'leave.comp.earned': 'Phép cơ bản',
  'leave.comp.positionBonus': 'Thưởng chức vụ',
  'leave.comp.recognitionBonus': 'Thưởng ghi nhận',
  'leave.comp.hrAdjustment': 'Điều chỉnh HR',
  'leave.comp.seniority': 'Thâm niên',
  // Phép chuyển năm Q1 (Chunk 3)
  'leave.carryover.valid': 'Phép chuyển từ năm trước:',
  'leave.carryover.expired': 'Phép chuyển năm trước (đã hết hạn)',
  'leave.carryover.days': 'ngày',
  'leave.carryover.expiresOn': 'hết hạn',
  'leave.carryover.expiredOn': 'đã hết hạn vào',
  'leave.history': 'Lịch sử nghỉ phép',
  'leave.type': 'Loại',
  'leave.from': 'Từ ngày',
  'leave.to': 'Đến ngày',
  'leave.days': 'Số ngày',
  'leave.reason': 'Lý do',
  'leave.status': 'Trạng thái',
  'leave.holidays': 'Ngày lễ',
  'leave.recurring': 'Hàng năm',
  'leave.empty': 'Không có dữ liệu nghỉ phép.',
  // Leave history sub-tabs
  'leave.hist.all': 'Tất cả',
  'leave.hist.active': 'Đang hiệu lực',
  'leave.hist.completed': 'Đã hoàn thành',
  'leave.hist.cancelled': 'Đã hủy',
  // Leave request — form & list
  'leave.requestLeave': 'Xin nghỉ',
  'leave.myRequests': 'Đơn nghỉ của tôi',
  'leave.leaveType': 'Loại nghỉ',
  'leave.type.ANNUAL': 'Nghỉ phép năm',
  'leave.type.UNPAID': 'Nghỉ không lương',
  'leave.type.LATE': 'Đi muộn',
  'leave.type.EARLY': 'Về sớm',
  'leave.type.LATE_EARLY': 'Đi muộn / Về sớm',
  'leave.type.BEREAVEMENT': 'Nghỉ tang',
  'leave.type.WEDDING': 'Nghỉ cưới',
  'leave.type.REMOTE': 'Remote',
  'leave.type.PATERNITY': 'Nghỉ vợ đẻ',
  'leave.session': 'Buổi',
  'leave.session.morning': 'Buổi sáng',
  'leave.session.afternoon': 'Buổi chiều',
  'leave.session.fullday': 'Cả ngày',
  'leave.session.1h': '1 giờ (0.15 ngày)',
  'leave.session.2h': '2 giờ (0.30 ngày)',
  'leave.session.3h': '3 giờ (0.46 ngày)',
  'leave.session.4h': '4 giờ (0.62 ngày)',
  'leave.date': 'Ngày',
  'leave.lateEarlyDuration': 'Thời gian',
  'leave.submitRequest': 'Gửi đơn',
  'leave.cancelRequest': 'Hủy đơn',
  'leave.confirmCancel': 'Bạn có chắc muốn hủy đơn nghỉ này?',
  'leave.requestSuccess': 'Đơn nghỉ đã được gửi thành công.',
  'leave.status.ACTIVE': 'Đang hiệu lực',
  'leave.status.COMPLETED': 'Đã hoàn thành',
  'leave.status.CANCELLED_BY_USER': 'Đã hủy',
  'leave.status.CANCELLED_BY_HR': 'HR hủy',
  'leave.noRequests': 'Chưa có đơn nghỉ nào.',
  'leave.requestsLoading': 'Đang tải đơn nghỉ…',
  // Shared tabs
  'tabs.directory': 'Danh sách',
  'tabs.overview': 'Tổng quan',
  'tabs.salary': 'Lương',
  'tabs.contracts': 'Hợp đồng',
  'tabs.leaveRequest': 'Xin nghỉ',
  'tabs.leaveHistory': 'Lịch sử',
  'tabs.publicHolidays': 'Ngày lễ',
  'tabs.workSchedule': 'Lịch làm việc',
  'tabs.dutySchedule': 'Lịch trực nhật',
  // Working-days summary table
  'wd.title': 'Ngày công & Phép năm',
  'wd.col.month': 'Tháng',
  'wd.col.total': 'Tổng ngày công',
  'wd.col.unpaid': 'Nghỉ không lương',
  'wd.col.actual': 'Ngày công thực',
  'wd.col.earned': 'Phép tích lũy',
  'wd.col.used': 'Đã dùng',
  'wd.col.remaining': 'Còn lại',
  'wd.noData': 'Chưa có dữ liệu ngày công.',
  // HR Leave Management tabs
  'hrleave.tab.balances': 'Số dư phép',
  'hrleave.tab.activeRequests': 'Lịch sử nghỉ phép',
  // HR Leave History — status pills + filters + table cols
  'hrleave.req.all': 'Tất cả',
  'hrleave.req.active': 'Đang hiệu lực',
  'hrleave.req.completed': 'Hoàn thành',
  'hrleave.req.cancelled': 'Đã hủy',
  'hrleave.req.allMonths': 'Tất cả tháng',
  'hrleave.req.monthLabel': 'Tháng',
  'hrleave.req.allTypes': 'Tất cả loại',
  'hrleave.req.allEmployees': 'Tất cả NV',
  'hrleave.req.colDates': 'Ngày',
  'hrleave.req.colTime': 'Thời gian',
  'hrleave.req.colActions': 'Thao tác',
  'hrleave.tab.workingDays': 'Ngày công',
  'hrleave.tab.workSchedules': 'Lịch làm việc',
  'hrleave.tab.logs': 'Nhật ký',
  'hrleave.tab.addLeave': 'Thêm nghỉ phép',
  'hrleave.tab.specialLeave': 'Nghỉ đặc biệt',
  // Leave management tab
  'leaveManagement.allBalances': 'Ngày phép toàn công ty',
  'leaveManagement.employee': 'Nhân viên',
  'leaveManagement.officialDate': 'Ngày chính thức',
  'leaveManagement.baseDays': 'Cơ bản',
  'leaveManagement.positionBonus': 'Chức vụ',
  'leaveManagement.totalGranted': 'Tổng được cấp',
  'leaveManagement.usedFromPrevYear': 'Đã trừ phép năm trước',
  'leaveManagement.seniorityDays': 'Phép thâm niên',
  'leaveManagement.recognitionBonus': 'Thẻ ghi nhận',
  'leaveManagement.hrAdjustment': 'Điều chỉnh',
  // HR adjust balance modal (phase 7a)
  'hrleave.reason': 'Lý do (tùy chọn)',
  // HR add leave form (phase 7a)
  'hrleave.addLeave': 'Bổ sung ngày nghỉ cho nhân viên',
  'hrleave.addLeaveSubtitle': 'Dùng để bổ sung ngày nghỉ bị thiếu của nhân viên (nghỉ nhưng quên đăng ký)',
  'hrleave.addLeaveSubmit': 'Bổ sung',
  'hrleave.selectEmployee': 'Chọn nhân viên',
  'hrleave.addSuccess': 'Đã tạo bản ghi nghỉ phép',
  // HR active requests (phase 7b)
  'hrleave.tab.manageHolidays': 'Quản lý ngày lễ',
  'hrleave.deleteRequest': 'Xóa đơn',
  'hrleave.confirmDeleteRequest': 'Bạn có chắc muốn xóa đơn nghỉ này? Hành động không thể hoàn tác.',
  // HR holidays CRUD (phase 7b)
  'hrleave.holidays.add': 'Thêm ngày lễ',
  'hrleave.holidays.edit': 'Sửa',
  'hrleave.holidays.delete': 'Xóa ngày lễ',
  'hrleave.holidays.confirmDelete': 'Bạn có chắc muốn xóa ngày lễ này?',
  'hrleave.holidays.name': 'Tên ngày lễ',
  'hrleave.holidays.startDate': 'Ngày bắt đầu',
  'hrleave.holidays.endDate': 'Ngày kết thúc (tùy chọn)',
  'hrleave.holidays.year': 'Năm',
  'hrleave.holidays.recurring': 'Lặp hàng năm',
  'hrleave.holidays.recurringBadge': 'Hàng năm',
  'hrleave.holidays.month': 'Tháng',
  // HR Working Days all-employees tab (phase 7c)
  'hrleave.wd.employee': 'Nhân viên',
  'hrleave.wd.noData': 'Chưa có dữ liệu ngày công cho năm này.',
  'hrleave.wd.filterEmployee': 'Lọc theo nhân viên',
  // HR Work Schedules tab (phase 7c)
  'hrleave.sched.openWindows': 'Cửa sổ đăng ký đang mở',
  'hrleave.sched.noOpenWindows': 'Không có cửa sổ đăng ký nào đang mở.',
  'hrleave.sched.openWindow': 'Mở cửa sổ',
  'hrleave.sched.closeWindow': 'Đóng cửa sổ',
  'hrleave.sched.confirmClose': 'Đóng cửa sổ đăng ký này? Nhân viên sẽ không thể đăng ký lịch cho tháng này.',
  'hrleave.sched.deadline': 'Hạn chót',
  'hrleave.sched.openedAt': 'Mở lúc',
  'hrleave.sched.month': 'Tháng',
  'hrleave.sched.addWindow.title': 'Mở cửa sổ đăng ký',
  'hrleave.sched.addWindow.month': 'Tháng',
  'hrleave.sched.addWindow.deadline': 'Hạn chót (YYYY-MM-DD)',
  'hrleave.sched.title': 'Đăng ký giờ làm việc',
  'hrleave.sched.legend8h': '8h00 - Đặc cách',
  'hrleave.sched.legend830': '8h30 - Đã đăng ký',
  'hrleave.sched.legend9h': '9h00 - Đã đăng ký',
  'hrleave.sched.legendDefault': 'Mặc định',
  'hrleave.sched.totalEmployees': 'Tổng nhân viên',
  'hrleave.sched.showResigned': 'Hiện đã nghỉ việc',
  'hrleave.sched.code': 'Mã',
  'hrleave.sched.name': 'Họ tên',
  'hrleave.sched.allRequired': 'Vui lòng nhập đủ thông tin',
  'hrleave.sched.note2025Label': 'Năm 2025',
  'hrleave.sched.note2025': 'UA mặc định 9h, bộ phận khác mặc định 8h30.',
  'hrleave.sched.note2026Label': 'Từ 1/2026',
  'hrleave.sched.note2026': 'Nhân viên đăng ký trong 5 ngày cuối tháng cho tháng sau. Mặc định 9h nếu không đăng ký.',
  // HR Special Leave tab (phase 7c)
  'hrleave.special.leaveType': 'Loại',
  'hrleave.special.eventDate': 'Ngày sự kiện',
  'hrleave.special.expiresAt': 'Hết hạn',
  'hrleave.special.maxDays': 'Số ngày tối đa',
  'hrleave.special.usedDays': 'Đã dùng',
  'hrleave.special.remaining': 'Còn lại',
  'hrleave.special.status': 'Trạng thái',
  'hrleave.special.status.active': 'Đang hiệu lực',
  'hrleave.special.status.expired': 'Hết hạn',
  'hrleave.special.status.disabled': 'Đã tắt',
  'hrleave.special.noData': 'Chưa có bản ghi nghỉ đặc biệt.',
  'hrleave.special.enable': 'Bật',
  'hrleave.special.edit': 'Sửa',
  'hrleave.special.disable': 'Tắt',
  'hrleave.special.confirmDisable': 'Tắt nghỉ đặc biệt này? Nhân viên sẽ mất quyền sử dụng số ngày còn lại.',
  'hrleave.special.type.paternity': 'Nghỉ vợ đẻ',
  'hrleave.special.type.bereavement': 'Nghỉ tang',
  'hrleave.special.type.wedding': 'Nghỉ cưới',
  'hrleave.special.add.title': 'Bật nghỉ đặc biệt',
  'hrleave.special.edit.title': 'Sửa nghỉ đặc biệt',
  // HR Logs tab (phase 7c)
  'hrleave.logs.time': 'Thời gian',
  'hrleave.logs.actor': 'Người thực hiện',
  'hrleave.logs.action': 'Hành động',
  'hrleave.logs.changes': 'Thay đổi',
  'hrleave.logs.action.adjust': 'Điều chỉnh',
  'hrleave.logs.action.hr_add_leave': 'HR thêm',
  'hrleave.logs.action.delete': 'Xóa',
  'hrleave.logs.action.cancel': 'Hủy',
  'hrleave.logs.noData': 'Chưa có nhật ký.',
  'hrleave.logs.action.recognition_bonus': 'Thưởng ghi nhận',
  'hrleave.logs.action.hr_adjustment': 'Điều chỉnh phép',
  // G9: Import hàng loạt ngày lễ
  'hrleave.holidays.bulkImport': 'Import hàng loạt',
  'hrleave.holidays.bulkImportHelp': 'Mỗi dòng: YYYY-MM-DD, Tên ngày lễ  (thêm ,recurring cho ngày lặp hàng năm)',
  'hrleave.holidays.bulkImportRun': 'Import',
  'hrleave.holidays.bulkInserted': 'đã thêm',
  'hrleave.holidays.bulkSkipped': 'bỏ qua',
  'hrleave.holidays.bulkErrors': 'lỗi',
  // G11: Chi tiết phép tích lũy + thưởng ghi nhận
  'leave.breakdown.toggle': 'Chi tiết phép',
  'leave.breakdown.title': 'Chi tiết ngày phép tích lũy',
  'hrleave.recognition.setTitle': 'Đặt thưởng ghi nhận (ngày)',
  'hrleave.recognition.current': 'Hiện tại',
  // Điều chỉnh phép có dấu: âm = trừ phép đã nghỉ trước (phép vay)
  'hrleave.adjustment.setTitle': 'Điều chỉnh phép (ngày)',
  'hrleave.adjustment.hint': 'Số âm để trừ phép đã ứng trước (phép vay), số dương để cộng thêm. 0 = bỏ điều chỉnh. Không dùng cho ngày nghỉ đã có đơn trong lịch sử — đơn đó đã tính vào Đã dùng.',
  'hrleave.adjustment.invalid': 'Giá trị phải là số (bước 0,5).',
  'hrleave.adjustment.reasonRequired': 'Cần ghi lý do khi trừ phép.',
  'hrleave.adjustment.reasonLabel': 'Lý do (bắt buộc khi trừ phép)',
  'hrleave.recognition.invalid': 'Giá trị phải là số không âm.',
  // G10: Lịch trực nhật
  'hrleave.tab.dutySchedule': 'Lịch trực nhật',
  'hrleave.duty.assignDay': 'Phân công trực',
  'hrleave.duty.employee1': 'Nhân viên 1',
  'hrleave.duty.employee2': 'Nhân viên 2 (tùy chọn)',
  'hrleave.duty.selectEmployee': '-- Chọn nhân viên --',
  'hrleave.duty.save': 'Lưu',
  'hrleave.duty.clear': 'Xóa',
  'hrleave.duty.confirmClear': 'Xóa phân công trực nhật cho ngày này?',
  'hrleave.duty.saveSuccess': 'Đã lưu phân công trực nhật.',
  'hrleave.duty.clearSuccess': 'Đã xóa phân công trực nhật.',
  'hrleave.duty.duplicateError': 'Không thể phân công cùng một nhân viên cho cả hai vị trí.',
  // G12: Bảng thống kê lương
  'hrleave.tab.salaryStats': 'Thống kê lương',
  'hrleave.salary.eCode': 'Mã NV',
  'hrleave.salary.eName': 'Họ tên',
  'hrleave.salary.department': 'Phòng ban',
  'hrleave.salary.netSalary': 'Lương net',
  'hrleave.salary.standardDays': 'Ngày chuẩn',
  'hrleave.salary.actualDays': 'Ngày thực',
  'hrleave.salary.actualReceived': 'Thực nhận',
  'hrleave.salary.note': 'Ghi chú',
  'hrleave.salary.estimated': 'Ước tính',
  'hrleave.salary.estimatedNote': 'Ngày thực được ước tính (không có dữ liệu ngày công HR cho tháng này)',
  'hrleave.salary.noData': 'Không có dữ liệu lương cho tháng này.',
  'hrleave.salary.totalEmployees': 'Nhân viên',
  'hrleave.salary.totalNetSalary': 'Tổng lương net',
  'hrleave.salary.totalActualReceived': 'Tổng thực nhận',
  // G12: Tab sự kiện hàng ngày (skeleton)
  'hrleave.tab.dailyEvents': 'Sự kiện ngày',
  'hrleave.dailyEvents.comingSoon': 'Chưa khả dụng',
  'hrleave.dailyEvents.dataGapNote': 'Dữ liệu sự kiện hàng ngày (thử thách và đặt cơm) được lưu trong file JSON trên ERP. Chưa có ETL nhập vào system-erp.',
  'hrleave.dailyEvents.challenges': 'Thử thách',
  'hrleave.dailyEvents.foodEvents': 'Sự kiện đặt cơm',
  // G12: Tab nhật ký đăng nhập
  'hrleave.logs.filterYear': 'Năm',
  'hrleave.logs.filterMonth': 'Tháng',
  'hrleave.logs.filterFrom': 'Từ ngày',
  'hrleave.logs.filterTo': 'Đến ngày',
  'hrleave.logs.filterSearch': 'Tìm kiếm',
  'hrleave.logs.filterSearchPlaceholder': 'Email hoặc tên…',
  'hrleave.logs.totalSessions': 'Tổng phiên',
  'hrleave.logs.uniqueUsers': 'Người dùng',
  'hrleave.logs.failedNote': 'Lưu ý: Đăng nhập thất bại (tài khoản chưa được cấp quyền) được ghi nhận từ 14/07/2026.',
  'hrleave.logs.failed': 'thất bại',
  'hrleave.logs.failedLogins': 'Đăng nhập thất bại',
  'hrleave.logs.people': 'người',
  'hrleave.logs.user': 'Nhân sự',
  'hrleave.logs.device': 'Thiết bị',
  'hrleave.logs.timeRange': 'Thời gian',
  'hrleave.logs.deviceMobile': 'Điện thoại',
  'hrleave.logs.deviceTablet': 'Máy tính bảng',
  'hrleave.logs.deviceDesktop': 'Máy tính',
  'hrleave.logs.noLoginLogs': 'Không có bản ghi đăng nhập.',
  'hrleave.logs.sessionCount': 'Số phiên',
  'hrleave.logs.type': 'Loại',
  'hrleave.logs.typeEmployee': 'EMPLOYEE',
  'hrleave.logs.typeDev': 'DEV',
  'hrleave.logs.typeOther': 'KHÁC',
  'hrleave.logs.sessionAt': 'Phiên lúc',
  'hrleave.logs.pagesVisited': 'trang đã xem',
  'hrleave.logs.noActivity': 'Không có hoạt động ghi nhận (log bắt đầu từ 08/07/2026)',
  'hrleave.logs.viewActivity': 'Xem hoạt động',
};
